export default __webpack_public_path__ + "static/media/dole-logo@3x.30c49bd5.png";